import dayjs from 'dayjs';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

import { CurrenciesEnum, EMPTY_DEFAULT } from '@anyx/shared-utils';


import { NumberWithCurrency, NumberWithFormat, NumberWithPercentage } from '../../atoms';

import { NumberFormat } from './MultiValueTooltip';

export const SingleValueTooltip = ({
  active,
  payload,
  footerContent,
  dataKeyTranslation,
}: TooltipProps<ValueType, NameType> & {
  footerContent?: React.ReactNode;
  dataKeyTranslation?: (dataKey?: string | number) => string;
}) => {
  const formatNumber = ({
    numberFormat,
    value,
    currency,
  }: {
    numberFormat: string;
    value: number;
    currency: CurrenciesEnum;
  }) => {
    switch (numberFormat) {
      case NumberFormat.PRICE:
        return (
          <NumberWithCurrency
            amount={value}
            currency={currency}
            currencyClassName="ml-0.5 text-4xs"
          />
        );
      case NumberFormat.PERCENTAGE:
        return <NumberWithPercentage amount={value} />;
      default:
        return value ? <NumberWithFormat amount={+value} /> : EMPTY_DEFAULT;
    }
  };
  if (active && payload) {
    return (
      <div
        className={
          'shadow-tooltip relative translate-x-1 -translate-y-[calc(50%+1rem)] rounded-sm bg-[#475563]/95 p-2 text-white'
        }
      >
        {payload.map((item, i) => {
          const { key, name, numberFormat, value, currency } = item?.payload || {};
          return (
            <div key={i}>
              <p className="text-4xs font-semibold">
                {dayjs(new Date(key)).isValid() && typeof key === 'number'
                  ? `${dayjs(key).format('YYYY/MM/DD')} (${dayjs(key).format('dddd')})`
                  : dataKeyTranslation
                    ? dataKeyTranslation(key)
                    : key}
              </p>
              <p className="text-4xs font-semibold">{name}</p>
              <p className="text-sm font-semibold">
                {formatNumber({
                  numberFormat: numberFormat,
                  value: value,
                  currency: currency,
                })}
              </p>
            </div>
          );
        })}
        {footerContent}
      </div>
    );
  }

  return null;
};
